import { Component, OnInit } from '@angular/core';
import { UscTableViewComponent } from '../usc-table-view/usc-table-view.component';

@Component({
    selector: 'sn-usc-scorecard-detailed-results',
    templateUrl: '../usc-table-view/usc-table-view.component.html',
    styleUrls: ['../usc-table-view/usc-table-view.component.css']
})  

export class UscScorecardDetailedResultsComponent extends UscTableViewComponent {

    ngOnInit() {
        this.view = this.uscStoreService.view_p2w_quota_gross_adds_detail_results;
        this.isPreviousMonthEnabled = false;
        this.enabled_include_todays_sales = false;
        this.is_current_month = true;

        super.ngOnInit();
    }

    updateDetailedResults(month:string) {
        this.current_month = month;
        this.is_current_month = this.current_month == this.uscStoreService.getThisMonthActionPlanSubject();
        this.is_previous_month = this.current_month != this.uscStoreService.getThisMonthActionPlanSubject();
        this.reloadItems();
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store-mobile/usc-scorecard-detailed-results/usc-scorecard-detailed-results.component.ts